export {};

declare global {
  interface Date {
    formatDate(formatType: "forApi" | "week" | "day"  | "fullDay" | "month", showYear?: boolean): string;

    getWeekNumber(): number;
  }
}

Date.prototype.getWeekNumber = function (): number {
  const d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}

Date.prototype.formatDate = function (formatType: "forApi" | "week" | "day" | "fullDay" | "month", showYear: boolean = true): string {
  const DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
  const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];

  switch (formatType) {
    case "forApi":
      return `${this.getFullYear()}-${(this.getMonth() + 1).toString().padStart(2, "0")}-${this.getDate().toString().padStart(2, "0")}`;
    case "week":
      const dayOfWeek = (this.getDay() + 6) % 7;
      const firstDayOfWeek = new Date(this);
      firstDayOfWeek.setDate(this.getDate() - dayOfWeek);

      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

      return `Sem. #${this.getWeekNumber()} - ${firstDayOfWeek.formatDate("day", showYear)} au ${lastDayOfWeek.formatDate("day", showYear)}`;
    case "day":
      let returnText: string = `${this.getDate().toString().padStart(2, "0")}/${(this.getMonth() + 1).toString().padStart(2, "0")}`;
      if (showYear) returnText += `/${this.getFullYear()}`;

      return returnText;
    case "fullDay":
      const day = DAYS[(this.getDay() + 6) % 7];
      const month = MONTHS[this.getMonth()];
      let fullDayText = `${day}. ${this.getDate()} ${month}.`;
      if (showYear) fullDayText += ` ${this.getFullYear()}`;
      return fullDayText;
    case "month":
      return MONTHS[this.getMonth()] + (showYear ? `. ${this.getFullYear()}` : ".");
  }
};
